module.exports = __webpack_public_path__ + "assets/img/block-left-af3d5551.png";